<template>
  <!-- 机械表历史数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <!-- 第一行 -->
        <a-row :gutter="24" class="search-row">
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="用户" class="search-form-item">
              <UserSelect v-model="query.userCode" @change="onUserSelectChange" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="用水性质" class="search-form-item">
              <a-select
                v-model="query.waterUsageType"
                placeholder="请选择"
                allow-clear
                style="width: 100%"
              >
                <a-select-option :value="1">居民用水</a-select-option>
                <a-select-option :value="2">非居民用水</a-select-option>
                <a-select-option :value="3">特种用水</a-select-option>
                <a-select-option :value="4">工业用水</a-select-option>
                <a-select-option :value="5">混合用水</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="表册分组" class="search-form-item">
              <a-select 
                placeholder="请选择" 
                v-model="query.groupId" 
                allow-clear 
                @change="onGroupChange"
                style="width: 100%"
              >
                <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="选择表册" class="search-form-item">
              <a-select
                placeholder="请选择"
                v-model="query.meterBookId"
                :loading="meterBooksLoading"
                allow-clear
                show-search
                :filter-option="filterMeterBookOption"
                :disabled="!query.groupId"
                style="width: 100%"
              >
                <a-select-option v-for="item in allMeterBooksList" :key="item.id" :value="String(item.id)">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 第二行 -->
        <a-row :gutter="24" class="search-row">
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="抄表员" class="search-form-item">
              <a-select
                show-search
                :filter-option="filterReaderOption"
                v-model="query.readerId"
                placeholder="请输入抄表员名称搜索"
                @search="getReaderList"
                allow-clear
                style="width: 100%"
              >
                <a-select-option v-for="item in readerList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="抄表时间" class="search-form-item">
              <a-range-picker
                v-model="dateRange"
                @change="onDateRangeChange"
                style="width: 100%"
                format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="环比增长率" class="search-form-item">
              <div class="range-input-container">
                <a-input
                  v-model="query.minGrowthRate"
                  placeholder="最小值"
                  allow-clear
                  @input="validateNumber('minGrowthRate')"
                />
                <div class="circle">~</div>
                <a-input
                  v-model="query.maxGrowthRate"
                  placeholder="最大值"
                  allow-clear
                  @input="validateNumber('maxGrowthRate')"
                />
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="水表状况" class="search-form-item">
              <a-select
                v-model="query.meterStatus"
                placeholder="请选择"
                allow-clear
                style="width: 100%"
              >
                <a-select-option :value="1">正常</a-select-option>
                <a-select-option :value="2">异常</a-select-option>
                <a-select-option :value="3">取表</a-select-option>
                <a-select-option :value="4">关闸</a-select-option>
                <a-select-option :value="5">重转</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- 按钮组单独一行 -->
        <a-row :gutter="24" class="search-row">
          <a-col :md="24" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <div class="button-group">
                <a-button type="primary" @click="searchList">查询</a-button>
                <a-button @click="resetList">重置</a-button>
                <a-button type="primary" :loading="exportLoading" @click="exportHandleIdList()" v-action:export>
                  导出
                </a-button>
                <a-button class="sup-btn" type="primary" @click="supplementDate()">补推数据</a-button>
                <a-button class="sup-btn" type="primary" @click="handleManualAdd()">补录数据</a-button>
                <a-button type="danger" @click="handleBatchDelete()" v-action:del>批量删除</a-button>
                <!-- v-action:del -->
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      size="middle"
      rowKey="id"
      bordered
      :scroll="{ x: 2000 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <div class="action-container">
          <a @click="handleViewImage(record)">查看图片</a>
          <a @click="handleEdit(record)">纠正</a>
        </div>
      </span>
      <template slot="growthRate" slot-scope="text">
        <span>{{ formatGrowthRate(text) }}</span>
      </template>
      <template slot="meterStatus" slot-scope="text">
        <a-tag :color="getMeterStatusColor(text)">{{ text }}</a-tag>
      </template>
    </a-table>
    <!-- 补推数据 -->
    <a-modal style="top: 20px" :width="500" :visible="visible" @ok="approvalDateko" @cancel="handleCancel">
      <template slot="title">
        <a-icon
          type="info-circle"
          theme="twoTone"
          twoToneColor="#ff4d4f"
          :style="{ fontSize: '18px', marginRight: '5px' }"
        />提示</template
      >
      <div class="prompt">
        <p>
          请确认是否将勾选的 <strong>{{ selectedRows.length }}</strong> 条数据推送到营收系统？
        </p>
      </div>
    </a-modal>

    <!-- 查看图片 -->
    <a-modal
      title="查看图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="imageVisible"
      @cancel="handleImageCancel"
    >
      <div v-if="currentImagePath">
        <img :src="currentImagePath" alt="抄表图片" style="width: 100%; max-height: 500px; object-fit: contain" />
      </div>
      <div v-else>
        <a-alert message="该记录没有图片" type="info" />
      </div>
    </a-modal>

    <!-- 纠正数据 -->
    <a-modal
      title="纠正数据"
      style="top: 20px"
      :width="600"
      :visible="editVisible"
      @ok="handleEditSubmit"
      @cancel="handleEditCancel"
      :confirmLoading="editLoading"
    >
      <a-form-model
        ref="editForm"
        :model="editForm"
        :rules="editRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        style="padding-top: 20px;"
      >
        <a-form-model-item label="用户编码">
          <a-input v-model="editForm.userCode" disabled />
        </a-form-model-item>
        <a-form-model-item label="用户名称">
          <a-input v-model="editForm.userName" disabled />
        </a-form-model-item>
        <a-form-model-item label="上期行至">
          <a-input v-model="editForm.previousReading" disabled />
        </a-form-model-item>
        <a-form-model-item label="本期行至" prop="currentReading">
          <a-input
            v-model="editForm.currentReading"
            type="number"
            placeholder="请输入本期读数"
            :min="0"
            :step="0.01"
          />
        </a-form-model-item>
        <a-form-model-item label="本期用水量" prop="currentConsumption">
          <a-input
            v-model="editForm.currentConsumption"
            type="number"
            placeholder="请输入本期用水量"
            :min="0"
            :step="0.01"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="editForm.remark" :rows="3" placeholder="请输入备注信息（可选）" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 补录数据 -->
    <a-modal
      title="补录数据"
      style="top: 20px;"
      :width="600"
      :visible="manualAddVisible"
      @ok="handleManualAddSubmit"
      @cancel="handleManualAddCancel"
      :confirmLoading="manualAddLoading" 
    >
      <a-form-model
        ref="manualAddForm"
        :model="manualAddForm"
        :rules="manualAddRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        style="padding-top: 20px;"
      >
        <a-form-model-item label="用户" prop="userCode">
          <UserSelect v-model="manualAddForm.userCode" @change="onManualAddUserChange" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="上期读数" prop="previousReading">
          <a-input
            v-model="manualAddForm.previousReading"
            type="number"
            placeholder="请输入上期读数"
            :min="0"
            :step="0.01"
          />
        </a-form-model-item>
        <a-form-model-item label="旧表读数" prop="oldMeterReading">
          <a-input
            v-model="manualAddForm.oldMeterReading"
            type="number"
            placeholder="请输入旧表读数"
            :min="0"
            :step="0.01"
          />
        </a-form-model-item>
        <a-form-model-item label="上期抄表时间" prop="previousReadingTime">
          <a-date-picker
            v-model="manualAddForm.previousReadingTime"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="请选择上期抄表时间"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="本期读数" prop="currentReading">
          <a-input
            v-model="manualAddForm.currentReading"
            type="number"
            placeholder="请输入本期读数"
            :min="0"
            :step="0.01"
          />
        </a-form-model-item>
        <a-form-model-item label="本期抄表时间" prop="currentReadingTime">
          <a-date-picker
            v-model="manualAddForm.currentReadingTime"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="请选择本期抄表时间"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="抄表员姓名" prop="readerName">
          <a-select
            v-model="manualAddForm.readerName"
            placeholder="请选择抄表员"
            show-search
            :filter-option="filterReaderOption"
            @search="getReaderList"
            allow-clear
            style="width: 100%"
          >
            <a-select-option v-for="item in readerList" :key="item.id" :value="item.readerName">
              {{ item.readerName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="水表状况" prop="meterStatus">
          <a-select v-model="manualAddForm.meterStatus" placeholder="请选择水表状况" style="width: 100%">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">异常</a-select-option>
            <a-select-option :value="3">取表</a-select-option>
            <a-select-option :value="4">关闸</a-select-option>
            <a-select-option :value="5">重转</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="manualAddForm.remark" :rows="3" placeholder="请输入备注信息（可选）" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import mixinViewModule from '@/mixin/common'
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'

const columns = [
  { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120 },
  { title: '用户名称', dataIndex: 'userName', key: 'userName', width: 120 },
  { title: '用户地址', dataIndex: 'userAddress', ellipsis: true, width: 180, key: 'userAddress' },
  { title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber', width: 120 },
  { title: '用水性质', dataIndex: 'waterUsageTypeName', key: 'waterUsageTypeName', width: 100 },
  { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 100 },
  { title: '上期抄表时间', dataIndex: 'previousReadingTime', key: 'previousReadingTime', width: 150 },
  { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
  { title: '本期抄表时间', dataIndex: 'currentReadingTime', key: 'currentReadingTime', width: 150 },
  { title: '上期用水量（m³）', dataIndex: 'previousConsumption', key: 'previousConsumption', width: 120 },
  { title: '本期用水量（m³）', dataIndex: 'currentConsumption', key: 'currentConsumption', width: 120 },
  { title: '补充水量', dataIndex: 'additionalWater', key: 'additionalWater', width: 100 },
  {
    title: '环比增长率（%）',
    dataIndex: 'growthRate',
    key: 'growthRate',
    width: 120,
    scopedSlots: { customRender: 'growthRate' },
  },
  {
    title: '水表状况',
    dataIndex: 'meterStatusName',
    key: 'meterStatusName',
    width: 100,
    scopedSlots: { customRender: 'meterStatus' },
  },
    { title: '旧表读数', dataIndex: 'oldMeterReading', key: 'oldMeterReading', width: 100 },

  { title: '抄表员', dataIndex: 'readerName', key: 'readerName', width: 100 },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 100 },
  { title: '所在表册', dataIndex: 'bookName', ellipsis: true, key: 'bookName', width: 150 },
  { title: '备注', dataIndex: 'remark', key: 'remark', width: 120, ellipsis: true },
  {
    title: '操作',
    width: 120,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'right',
  },
]

export default {
  components: {
    dayjs,
    UserSelect,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data() {
    return {
      isMonth: false,
      dayjs,
      importLoading: false,
      visible: false,
      imageVisible: false,
      currentImagePath: '',
      manualAddVisible: false,
      manualAddLoading: false,
      editVisible: false,
      editLoading: false,
      editForm: {
        id: '',
        userCode: '',
        userName: '',
        previousReading: '',
        currentReading: '',
        currentConsumption: '',
        remark: '',
      },
      editRules: {
        currentReading: [
          { required: true, message: '请输入本期读数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) < 0) {
                callback(new Error('本期读数不能为负数'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        currentConsumption: [
          { required: true, message: '请输入本期用水量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) < 0) {
                callback(new Error('本期用水量不能为负数'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      manualAddForm: {
        userCode: '',
        previousReading: '',
        oldMeterReading: '',
        previousReadingTime: '',
        currentReading: '',
        currentReadingTime: '',
        readerName: '',
        meterStatus: '',
        remark: '',
      },
      manualAddRules: {
        userCode: [{ required: true, message: '请选择用户', trigger: 'change' }],
        previousReading: [
          { required: true, message: '请输入上期读数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) < 0) {
                callback(new Error('上期读数不能为负数'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        previousReadingTime: [{ required: true, message: '请选择上期抄表时间', trigger: 'change' }],
        oldMeterReading: [
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) < 0) {
                callback(new Error('旧表读数不能为负数'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        currentReading: [
          { required: true, message: '请输入本期读数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) < 0) {
                callback(new Error('本期读数不能为负数'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        currentReadingTime: [{ required: true, message: '请选择本期抄表时间', trigger: 'change' }],
        //readerName: [{ required: true, message: '请选择抄表员', trigger: 'change' }],
       // meterStatus: [{ required: true, message: '请选择水表状况', trigger: 'change' }],
      },
      endOpen: false,
      disabled: false,
      fileList: [],
      queryUrl: '/meter-manager/mechanical_tables/page',
      exportDataUrl: 'meter-manager/mechanical_tables/export',
      bookTreeData: [], // 表册列表
      groupListUrl: '/meter-manager/meter_book_groups/list',
      meterBooksUrl: '/meter-manager/meterBooks/list',
      GroupList: [], // 分组列表
      allMeterBooksList: [], // 所有表册列表
      meterBooksLoading: false, // 表册加载状态
      query: {
        userCode: '',
        meterNumber: '',
        taskStatus: '',
        groupId: '', // 分组ID
        meterBookId: '', // 表册ID
        readerId: '', // 抄表员ID
        startDate: '', // 抄表开始时间
        endDate: '', // 抄表结束时间
        minGrowthRate: '', // 最小环比增长率
        maxGrowthRate: '', // 最大环比增长率
        meterStatusName: '', // 水表状况
        meterStatus: '', // 水表状况(1:正常,2:异常,3:取表,4:关闸,5:重转)
        minConsumption: '', // 最小用水量
        maxConsumption: '', // 最大用水量
        remark: '', // 备注
        waterUsageType: '', // 用水性质
      },
      dateRange: [], // 日期范围选择器

      engineeringProjectEstab: {
        name: '',
        taskFrequency: '',
        cycleCount: '',
        startValue: '',
        endValue: '',
        taskStatus: 0,
        state: 0,
        dataType: '',
        bookId: '',
        bookGroup: '',
        staffId: '',
        endTime: '',
        startTime: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      rule: {
        name: [{ required: true, message: '请输入计划名称', trigger: 'change' }],
        taskFrequency: [{ required: true, message: '请选择计划周期', trigger: 'change' }],
        cycleCount: [{ required: true, message: '请选择月份数', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        bookId: [{ required: true, message: '请选择表册', trigger: 'change' }],
        bookGroup: [{ required: true, message: '请选择组别', trigger: 'change' }],
        staffId: [{ required: true, message: '请选择抄表员', trigger: 'change' }],
      },
      readerList: [], // 抄表员下拉数据
    }
  },
 
  created() {
    this.getGroupList()
    this.getReaderList()
    this.queryList()
  },
  methods: {
    // 根据id 修改
    addOrUpdateHandle(id) {
      // console.log(id);
      this.disabled = true
      this.isUpdate = false
      // this.visibles = true
      this.currentId = id
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              userName: data.userName,
              taskFrequency: data.taskFrequency,
              cycleCount: data.cycleCount,
              startValue: data.startTime,
              endValue: data.endTime,
              taskStatus: data.taskStatus,
              state: data.state,
              dataType: data.dataType,
              bookId: data.bookId,
              bookGroup: data.bookGroup,
              staffId: data.staffId,
              endTime: data.endTime,
              startTime: data.startTime,
            }
            if (data.taskFrequency == '月') {
              this.isMonth = true
            } else {
              this.isMonth = false
            }
          })
          .catch(() => {})
      }
    },
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
      // 翻页时清空选择的行
      this.selectedRows = []
    },

    // 搜索查询（重置到第一页）
    searchList() {
      this.pagination.current = 1; // 搜索时重置到第一页
      this.queryList();
    },
    //获取机械表历史数据列表
    queryList() {
      const params = {
        ...this.query,
      }

      // 处理查询参数，去除空值
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })

      // 处理数字类型参数
      if (params.minGrowthRate) {
        params.minGrowthRate = parseFloat(params.minGrowthRate)
      }
      if (params.maxGrowthRate) {
        params.maxGrowthRate = parseFloat(params.maxGrowthRate)
      }
      if (params.minConsumption) {
        params.minConsumption = parseFloat(params.minConsumption)
      }
      if (params.maxConsumption) {
        params.maxConsumption = parseFloat(params.maxConsumption)
      }

      if (this.needPage) {
        params.page = this.pagination.current || 1
        params.limit = this.pagination.pageSize || 10
      }
      this.dataListLoading = true
      this.$http
        .post(this.queryUrl, params)
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
              // 如果当前页没有数据且不是第一页，自动跳转到第一页
              if (this.list.length === 0 && this.pagination.current > 1) {
                this.pagination.current = 1
                this.queryList()
                return
              }
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 时间
    disabledStartDate(current) {
      console.log(current, 'lll')
      return current && current < dayjs().endOf('day')
    },
    disabledEndDate(endValue) {
      console.log(this.engineeringProjectEstab.startValue, 'ppp')
      const startValue = this.engineeringProjectEstab.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChangejt(value) {
      if (value.target.value == 2) {
        this.apprOpinion = false
      } else {
        this.apprOpinion = true
      }
    },
    onChangeh(date, dateString) {
      console.log(dateString)
      this.engineeringProjectEstab.startTime = dateString
      // this.engineeringProjectEstab.startValue = dateString
    },
    onChanget(date, dateString) {
      this.engineeringProjectEstab.endTime = dateString
    },
    addOrUpdateH() {
      this.disabled = false
      // this.visibles = true
    },
    handleCancelh() {
      this.isMonth = false
      this.endOpen = false
      this.$refs.ruleForm.resetFields()
    },
    approvalDateko() {
      // 根据是否有勾选数据决定pushMode
      const pushMode = this.selectedRows.length > 0 ? 1 : 2 // 1: 勾选推送, 2: 全部推送
      
      const params = {
        pushMode: pushMode,
        fromHistory:true,
        // batchSize: this.selectedRows.length,
        auditIds: this.selectedRows.length > 0 ? this.selectedRows : [],
      }

      console.log('推送参数:', params)

        this.$http
          // .get('/meter-manager/mechanical_tables/push', {
          .post('/meter-manager/revenue/batchPush', params)
        .then((data) => {
          if (data.code === 0) {
            this.$message.success(data.message)
            this.visible = false
            this.selectedRows = []
            this.queryList() // 刷新列表
          } else {
            this.$message.error(data.message || '补推数据失败')
          }
        })
        .catch((error) => { 
        })
    },
    handleCancel() {
      this.visible = false
    },
    changeFrequency(val) {
      if (val == '月') {
        this.isMonth = true
      } else {
        this.isMonth = false
        this.engineeringProjectEstab.cycleCount = ''
      }
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values,
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    historyData() {
      this.$refs.historyModal.show()
    },
    getBookData() {
      this.$http.get(this.queryBookDateUrl).then(({ data }) => {
        this.bookTreeData = data
      })
    },
    // 日期范围选择器变化处理
    onDateRangeChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.query.startDate = dateStrings[0]
        this.query.endDate = dateStrings[1]
      } else {
        this.query.startDate = ''
        this.query.endDate = ''
      }
      // 日期变化时重置页码
      this.pagination.current = 1
    },

    handleViewImage(record) {
      if (record.imagePath) {
        this.currentImagePath = record.imagePath
        this.imageVisible = true
      } else {
        this.$message.warning('该记录没有图片')
      }
    },
    handleImageCancel() {
      this.imageVisible = false
      this.currentImagePath = ''
    },
    // 纠正数据 - 打开弹窗
    handleEdit(record) {
      if (!record || !record.id) {
        this.$message.error('无效的记录数据')
        return
      }
      this.editVisible = true
      // 填充表单数据
      this.editForm = {
        id: record.id,
        userCode: record.userCode || '',
        userName: record.userName || '',
        previousReading: record.previousReading || '',
        currentReading: record.currentReading || '',
        currentConsumption: record.currentConsumption || '',
        remark: record.remark || '',
      }
      // 清除验证
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate()
        }
      })
    },
    // 纠正数据 - 提交
    handleEditSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false
        }

        this.editLoading = true
        const params = {
          id: this.editForm.id,
          currentReading: parseFloat(this.editForm.currentReading),
          currentConsumption: parseFloat(this.editForm.currentConsumption),
          remark: this.editForm.remark || '',
        }

        this.$http
          .put('/meter-manager/mechanical_tables/edit', params)
          .then(({ data, code, message }) => {
            this.editLoading = false
            if (code === 0) {
              this.$message.success(message || '纠正数据成功')
              this.editVisible = false
              this.queryList() // 刷新列表
            } else {
              this.$message.error(message || '纠正数据失败')
            }
          })
          .catch((error) => {
            this.editLoading = false
            const errorMsg = error.response?.data?.message || error.message || '纠正数据失败，请稍后重试'
            this.$message.error(errorMsg)
          })
      })
    },
    // 纠正数据 - 取消
    handleEditCancel() {
      this.editVisible = false
      this.editForm = {
        id: '',
        userCode: '',
        userName: '',
        previousReading: '',
        currentReading: '',
        currentConsumption: '',
        remark: '',
      }
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate()
      }
    },

    supplementDate() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要补推的数据')
        return
      }
      this.visible = true
    },
    // 获取分组列表
    async getGroupList() {
      try {
        const response = await this.$http.get(this.groupListUrl)
        this.GroupList = response.data
      } catch (error) {
        this.$message.error('获取分组列表失败')
      }
    },
 
    // 分组变化时的处理
    onGroupChange(value) {
      this.query.meterBookId = '' // 清空表册选择
      this.pagination.current = 1 // 重置到第一页
      if (this.query.groupId) {
        this.getMeterBooksData(this.query.groupId)
      } else {
        this.allMeterBooksList = []
      }
    },
    // 抄表员下拉远程搜索
    getReaderList(search = '') {
      this.$http
        .get('/meter-manager/meter_readers/list', { params: { name: search } })
        .then(({ data }) => {
          this.readerList = data || []
        })
        .catch(() => {})
    },
    filterReaderOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 数字输入验证（支持负数）
    validateNumber(field) {
      const value = this.query[field]
      if (value && !/^-?\d*\.?\d*$/.test(value)) {
        // 如果不是数字格式（包括负数），清空输入
        this.query[field] = value.replace(/[^\d.-]/g, '')
        // 确保负号只能出现在开头
        if (this.query[field].indexOf('-') > 0) {
          this.query[field] = this.query[field].replace(/-/g, '')
        }
      }
    },
    getGrowthRateClass(rate) {
      if (!rate) return ''
      const numRate = parseFloat(rate)
      if (numRate > 50) return 'growth-rate-high'
      if (numRate > 20) return 'growth-rate-medium'
      if (numRate < -20) return 'growth-rate-low'
      return 'growth-rate-normal'
    },
    formatGrowthRate(rate) {
      if (!rate) return '-'
      return `${parseFloat(rate).toFixed(2)}%`
    },
    getMeterStatusColor(status) {
      const statusMap = {
        正常: 'green',
        异常: 'red',
        取表: 'orange',
        关闸: 'default',
      }
      return statusMap[status]  
    },
    // 重写重置方法，清空所有查询条件
    resetList() {
      this.query = {
        userCode: '',
        meterNumber: '',
        taskStatus: '',
        groupId: '',
        meterBookId: '',
        readerId: '',
        startDate: '',
        endDate: '',
        minGrowthRate: '',
        maxGrowthRate: '',
        meterStatusName: '',
        meterStatus: '', // 水表状况(1:正常,2:异常,3:取表,4:关闸,5:重转)
        minConsumption: '',
        maxConsumption: '',
        remark: '',
        waterUsageType: '',
      }
      this.dateRange = []
      this.pagination.current = 1 // 重置到第一页
      this.selectedRows = [] // 清空选择的行
      this.queryList()
    },
    // 清空选择
    clearSelection() {
      this.selectedRows = []
      this.$message.success('已清空选择')
    },

    // 获取表册列表（联动分组）
    getMeterBooksData(groupId = null) {
      if (!groupId) {
        this.allMeterBooksList = []
        return
      }
      this.$http
        .get(`/meter-manager/meter_reading_plans/meter-books?groupId=${groupId}`)
        .then(({ data }) => {
          console.log(data,'data');
          
          this.allMeterBooksList =data
        })
        .catch(() => {
          this.allMeterBooksList = []
        })
    },
    onUserSelectChange(value, user) {
      console.log('用户选择变化:', value, user)
      if (user) {
        this.query.userName = user.userName
        console.log('设置用户名:', user.userName)
      } else {
        this.query.userName = ''
        console.log('清空用户名')
      }
      // 用户选择变化时重置页码
      this.pagination.current = 1
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 补录数据 - 打开弹窗
    handleManualAdd() {
      this.manualAddVisible = true
      // 重置表单
      this.manualAddForm = {
        userCode: '',
        previousReading: '',
        oldMeterReading: '',
        previousReadingTime: '',
        currentReading: '',
        currentReadingTime: '',
        readerName: '',
        meterStatus: '',
        remark: '',
      }
      // 清除验证
      this.$nextTick(() => {
        if (this.$refs.manualAddForm) {
          this.$refs.manualAddForm.clearValidate()
        }
      })
    },
    // 补录数据 - 提交
    handleManualAddSubmit() {
      this.$refs.manualAddForm.validate((valid) => {
        if (!valid) {
          return false
        }
        
        // 验证本期读数应该大于等于上期读数
        const previousReading = parseFloat(this.manualAddForm.previousReading)
        const currentReading = parseFloat(this.manualAddForm.currentReading)
        
        if (currentReading < previousReading) {
          this.$message.error('本期读数不能小于上期读数')
          return false
        }

        // 验证时间：本期抄表时间应该晚于上期抄表时间
        if (
          this.manualAddForm.previousReadingTime &&
          this.manualAddForm.currentReadingTime
        ) {
          const previousTime = new Date(this.manualAddForm.previousReadingTime)
          const currentTime = new Date(this.manualAddForm.currentReadingTime)
          if (currentTime <= previousTime) {
            this.$message.error('本期抄表时间应该晚于上期抄表时间')
            return false
          }
        }

        this.manualAddLoading = true
        const params = {
          userCode: this.manualAddForm.userCode,
          currentReading: currentReading,
          currentReadingTime: this.manualAddForm.currentReadingTime,
          readerName: this.manualAddForm.readerName,
          previousReading: previousReading,
          oldMeterReading: this.manualAddForm.oldMeterReading ? parseFloat(this.manualAddForm.oldMeterReading) : null,
          previousReadingTime: this.manualAddForm.previousReadingTime,
          meterStatus: this.manualAddForm.meterStatus,
          remark: this.manualAddForm.remark || '',
        }

        this.$http
          .post('/meter-manager/mechanical_tables/manual-add', params)
          .then(({ data, code, message }) => {
            this.manualAddLoading = false
            if (code === 0) {
              this.$message.success(message || '补录数据成功')
              this.manualAddVisible = false
              this.queryList() // 刷新列表
            } else {
              this.$message.error(message || '补录数据失败')
            }
          })
          .catch((error) => {
            this.manualAddLoading = false
            const errorMsg = error.response?.data?.message || error.message || '补录数据失败，请稍后重试'
            this.$message.error(errorMsg)
          })
      })
    },
    // 补录数据 - 取消
    handleManualAddCancel() {
      this.manualAddVisible = false
      this.manualAddForm = {
        userCode: '',
        previousReading: '',
        oldMeterReading: '',
        previousReadingTime: '',
        currentReading: '',
        currentReadingTime: '',
        readerName: '',
        meterStatus: '',
        remark: '',
      }
      if (this.$refs.manualAddForm) {
        this.$refs.manualAddForm.clearValidate()
      }
    },
    // 补录数据 - 用户选择变化
    onManualAddUserChange(value, user) {
      if (user) {
        // 用户选择后可以在这里做一些处理
        console.log('补录数据选择的用户:', user)
      }
    },
    // 批量删除
    handleBatchDelete() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }

      this.$confirm({
        title: '删除确认',
        content: `您确定要删除选中的 ${this.selectedRows.length} 条数据吗？删除后无法恢复。`,
        okText: '确定删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.performBatchDelete()
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        },
      })
    },
    // 执行批量删除操作
    performBatchDelete() {
      this.dataListLoading = true
      this.$http
        .delete('/meter-manager/mechanical_tables/batch-delete',
        {
              data: this.selectedRows,
            })
        .then(({ code, message }) => {
          this.dataListLoading = false
          if (code === 0) {
            this.$message.success(message || `成功删除 ${this.selectedRows.length} 条数据`)
            this.selectedRows = []
            this.queryList() // 刷新列表
          } else {
            this.$message.error(message || '删除失败')
          }
        })
        .catch((error) => {
          this.dataListLoading = false
          const errorMsg = error.response?.data?.message || error.message || '删除失败，请稍后重试'
          this.$message.error(errorMsg)
        })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th {
  text-align: center;
  background-color: #fafafa;
  // font-weight: 600;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/.ant-table-tbody > tr:hover > td {
  background-color: #f5f5f5;
}

.growth-rate-high {
  color: #f5222d;
  font-weight: 600;
}

.growth-rate-medium {
  color: #fa8c16;
  font-weight: 600;
}

.growth-rate-low {
  color: #52c41a;
  font-weight: 600;
}

.growth-rate-normal {
  color: #1890ff;
}

.action-container {
  display: flex;
  gap: 8px;
}

.action-container a {
  color: #1890ff;
  text-decoration: none;
}

.action-container a:hover {
  color: #40a9ff;
}

.statistic-item {
  text-align: center;
}

.statistic-title {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.statistic-value {
  font-size: 24px;
  font-weight: 600;
  color: #1890ff;
}

.statistic-value.success {
  color: #52c41a;
}

.statistic-value.warning {
  color: #fa8c16;
}

.statistic-value.primary {
  color: #1890ff;
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px 24px;
}

.prompt {
  margin: 30px 25px 10px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 15px;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}

.sup-btn {
  margin-left: 12px; 
  color: white;
}

.growth rate {
  display: flex;
}

/deep/ .ant-form-item-children {
  position: relative;
  display: flex;
}

.circle {
  border: 1px solid #d9d9d9;
  width: 60px;
  border-radius: 50%;
  margin: 0 10px 0 10px;
  text-align: center;
}

.range-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-input-container .ant-input {
  flex: 1;
  min-width: 100px;
}

/* 查询表单样式优化 */


.search-row {
  margin-bottom: 16px;
}

.search-row:last-child {
  margin-bottom: 0;
}

.search-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

.search-form-item .ant-form-item-label {
  min-width: 80px;
  text-align: right;
  padding-right: 8px;
  line-height: 32px;
}

.search-form-item .ant-form-item-control {
  flex: 1;
  line-height: 32px;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 8px;
}

.button-group .ant-btn {
  margin: 0;
  height: 32px;
  min-width: 80px;
  flex-shrink: 0;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .search-form-item .ant-form-item-label {
    min-width: 70px;
    text-align: left;
    padding-right: 4px;
  }
  
  .button-group {
    justify-content: flex-start;
  }
  
  .button-group .ant-btn {
    min-width: 70px;
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .table-page-search-wrapper {
    padding: 12px;
  }
  
  .search-row {
    margin-bottom: 12px;
  }
  
  .button-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .button-group .ant-btn {
    width: 100%;
    margin-bottom: 8px;
  }
  
  .button-group .ant-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
